export const EXCLUDED_COURSE_IDS = new Set([]);

export const isCourseAllowed = (item) => {
  if (!item) return false;
  const id = Number(item.id);
  return !EXCLUDED_COURSE_IDS.has(id);
};

export const filterAllowedCourses = (courses) =>
  Array.isArray(courses) ? courses.filter(isCourseAllowed) : [];
